/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
  Button,
  Modal,
  Form as FormUi,
  Input,
  Checkbox,
  Dropdown,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import { MyNormalInput } from "../dynamicComponent/myInputs";
import ReadAxios from "../axiosComponent/read";
import { isEmpty } from "lodash";
import CreateAxios from "../axiosComponent/create";
import MandatoryMark from "../common/mandatorymark";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { MyInput } from "../dynamicComponent/myInputs";
import { DateData } from "../dynamicComponent/datepick";
import { translate } from "react-i18next";
import moment, { ISO_8601 } from "moment";

const ModalUndoBroadcast = ({
  values,
  touched,
  errors,
  isSubmitting,
  handleSubmit,
  setFieldValue,
  orderID,
  shipmentId,
  t,
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [Vendors, setVendors] = useState([]);
  const [VendorsGroup, setVendorsGroup] = useState([]);
  var vendorIndex = 0;

//   useEffect(() => {
//     // getAllVendors();
//   }, []);
  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
    // if (values.vendor) handleSubmit();
  };

  const handleSubmited = () => {
    let Shipment = {shipment_id : +shipmentId}
    CreateAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${orderID}/undo/broadcast`,
        payload: { ...Shipment },
      })
        .then((res) => {
          console.log('res>>', res);
          // if(res.status == 200) {
            setmodalOpen(false);
            window.location.reload();
          // }
        })
        .catch((err) => {
          console.log("shipment order failed >>> ", err.data);
        });  
  };

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        size="tiny"
        trigger={
          <Button
            type="button"
            onClick={handleOpen}
            size="mini"
            basic color="primary"
            // className="w3-blue w3-round w3-hover-blue"
          >
            {t("btn-name") || "Undo"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          {t("title") || "Re-Broadcast Shipment"}
        </Modal.Header>
        <Modal.Content>
            <p>{t("message") || "Are you sure you want to undo broadcast"}</p>
        </Modal.Content>
        <Modal.Actions>
          {/* {isSubmitting ? "Loading..." : ""} */}
          <Button
            type="submit"
            onClick={handleClose}
            // disabled={isSubmitting || (values.allVendors && values.broadcast_start_datetime, values.broadcast_end_datetime)  ? false : true}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("cancel") || "Cancel"}
          </Button>
          <Button
            type="submit"
            onClick={handleSubmited}
            // disabled={isSubmitting || (values.allVendors && values.broadcast_start_datetime, values.broadcast_end_datetime)  ? false : true}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("save") || "OK"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("undoBroadcast")(ModalUndoBroadcast)
);
